import NeedHelpBanner from "@core-components/help-banner/NeedHelpBanner";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Space, Stack } from "@mantine/core";
import SEO from "@modules/seo/SEO";
import { SkinSearchFeatures } from "../components/SkinSearchFeatures";
import { SkinSearchGrid } from "../components/SkinSearchGrid";
import { SkinSearchHero } from "../components/SkinSearchHero";
import { SkinSearchInfo } from "../components/SkinSearchInfo";
import { SkinSearchPopular } from "../components/SkinSearchPopular";
import { useSkinSearch } from "../hooks/useSkinSearch";

const SkinSearchPage = () => {
  const {
    search,
    setSearch,
    filteredChampionsAndSkins,
    scrollRef,
    handleScrollToSearch,
    loadData,
    popularSkins,
  } = useSkinSearch();
  const { t } = useAppTranslation("pages.skins.search");

  return (
    <>
      <SEO description={t("seo.description")} title={t("seo.title")} />
      <Stack align="center" justify="center">
        <SkinSearchHero onScrollClick={handleScrollToSearch} />

        <SkinSearchPopular loadData={loadData} popularSkins={popularSkins} />

        <SkinSearchGrid
          search={search}
          setSearch={setSearch}
          filteredChampionsAndSkins={filteredChampionsAndSkins}
          scrollRef={scrollRef}
        />

        <Space h="xl" />

        <SkinSearchInfo />

        <Space h="xl" />

        <NeedHelpBanner />

        <Space h="xl" />

        <SkinSearchFeatures />
      </Stack>
    </>
  );
};

export default SkinSearchPage;
